import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import FirebaseProvider from './providers/firebase';
import SpotifyProvider from './providers/spotify';

ReactDOM.render(
    <React.StrictMode>
        <FirebaseProvider>
            <SpotifyProvider>
                <Router>
                    <App />
                </Router>
            </SpotifyProvider>
        </FirebaseProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
